var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgGroup1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 219,
    height: 68,
    viewBox: "0 0 219 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1908 0.144531L48.5178 51.6234L74.5232 0.144531H96.3935L61.0611 67.8572H36.2503L0.0448608 0.144531H22.1908Z",
    fill: "#86BF4E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.097 67.8572L120.424 16.3783L146.475 67.8572H168.3L133.013 0.144531H108.156L71.9511 67.8572H94.097Z",
    fill: "#86BF4E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M120.287 41.0391L134.025 67.856H106.227L120.287 41.0391Z",
    fill: "#86BF4E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M218.747 16.9999V0.191406H144.912L153.641 16.9999H218.747Z",
    fill: "#86BF4E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M179.603 67.8553H218.749V51.0469H171.333L179.971 67.6638L179.603 67.8553Z",
    fill: "#86BF4E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M218.748 41.0892V27.6328H159.156L166.14 41.0892H218.748Z",
    fill: "#86BF4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgGroup1);
export default __webpack_public_path__ + "static/media/img_group_1.96fc0ac252db2d8d962a861f4261546e.svg";
export { ForwardRef as ReactComponent };